import React, { useEffect, useState } from 'react';
import AppRoutes from './routes/AppRoutes';
import { useAppDispatch, useAppSelector } from './store';
import { setLanguages } from './store/slices/configSlice';
import { fetchCampaignsList } from './store/slices/campaignSlice';
import { useOrganizationLanguages } from './hooks/useOrganizationLanguages';
import { useAuth } from './hooks/useAuth';
import { useReportAuth } from './hooks/useReportAuth';
import { getDocumentTitle } from './helpers/domainUtils';

const App: React.FC = () => {
  const [ready, setReady] = useState(false);
  const dispatch = useAppDispatch();
  const { data: organizationLanguages, isLoading: isLoadingLanguages } = useOrganizationLanguages();
  const { isAuthenticated } = useAuth();
  const { data: reportAuth, isLoading: reportAuthLoading } = useReportAuth();
  const campaigns = useAppSelector((state) => state.campaigns.campaigns);

  useEffect(() => {
    document.title = getDocumentTitle();
  }, []);

  useEffect(() => {
    if (organizationLanguages) {
      const allLanguages = organizationLanguages
        .map((lang) => ({
          LanguageId: lang.languageId,
          LanguageName: lang.languageName,
          IsDefault: lang.isDefault,
        }))
        .sort((a, b) => (a.IsDefault ? -1 : b.IsDefault ? 1 : 0));

      dispatch(setLanguages(allLanguages));
      setReady(true);
    }
  }, [organizationLanguages, dispatch]);

  useEffect(() => {
    if (isAuthenticated && reportAuth?.accessToken && !reportAuthLoading && campaigns.length === 0) {
      dispatch(fetchCampaignsList(reportAuth.accessToken));
    }
  }, [isAuthenticated, reportAuth?.accessToken, reportAuthLoading, campaigns.length, dispatch]);

  if (isLoadingLanguages || !ready) {
    return null;
  }

  return <AppRoutes />;
};

export default App;
